import React from 'react'

const Button = ({ children, outlined = false, isDisabled = false, onClick = () => { }, styles, ...rest }) => {
    return (
        <button
            onClick={onClick}
            disabled={isDisabled}
            className={`flex items-center justify-center px-3 py-1 border rounded-md ${isDisabled ? 'bg-[#A8AAAE14] text-[#A8AAAE] border-[#A8AAAE] cursor-not-allowed' : outlined ? 'bg-[#92288C14] text-[#92288C] border-[#92288C]' : 'bg-[#92288C] text-[#FFFFFF] border border-[#92288C]'} ${styles}`}
        >
            {children}
        </button>
    )
}

export default Button
